import Loadable from 'react-loadable';
import LoadableLoader from 'components/Loader/Loadable';

export const loadable = <Props = {}>(loader: Loadable.OptionsWithoutRender<Props>['loader']) => Loadable({
  loader,
  loading: LoadableLoader,
});
